import { defineMessages } from 'react-intl';

const scope = 'cb.screens.Preferences';

export default defineMessages({
  couldNotUpdatePreferencesError: {
    id: `${scope}.couldNotUpdatePreferencesError`,
    defaultMessage: 'Error! Could not update preferences.',
  },
  selectDistance: {
    id: `${scope}.selectDistance`,
    defaultMessage: 'Select Your Search Radius',
  },
  saveBtn: {
    id: `${scope}.saveBtnLabel`,
    defaultMessage: 'Save',
  },
});